import { useTranslate } from "@similarweb/i18n-provider";

import { TableWidget } from "../../../common/widget/table/TableWidget";
import { useNewsMetricsData } from "../../hooks/useNewsMetricsData";

import type { ExtendedNewsMetricsData } from "./types";
import { useNewsMetricsColumns } from "./useNewsMetricsColumns";

export const NewsMetricsTable = () => {
    const { translate } = useTranslate();
    const { data, isLoading } = useNewsMetricsData();
    const columnsConfig = useNewsMetricsColumns();

    return (
        <TableWidget<ExtendedNewsMetricsData>
            dataAutomation="news-metrics-card"
            columnConfig={columnsConfig}
            data={data}
            highlightedRowSelector={(record) => record.domain.isPrimary}
            isLoading={isLoading}
            title={translate("activation.alerts.news.metrics.news-metrics-widget.title")}
        />
    );
};
